import { useRouter } from 'next/router';

export default function useRestaurantSlug() {
    const router = useRouter();

    return router.query?.slug;
}
